import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {Payment} from '../../entities/payment.entity';

export interface PaymentCheckoutRecovery {
  recoverCheckout(): Observable<boolean>;
}

export interface PaymentVerificationRecovery {
  recoverVerification(payment: Payment, error: unknown): Observable<boolean>;
}

export const PAYMENT_CHECKOUT_RECOVERY = new InjectionToken<PaymentCheckoutRecovery>('PAYMENT_CHECKOUT_RECOVERY');
export const PAYMENT_VERIFICATION_RECOVERY = new InjectionToken<PaymentVerificationRecovery>('PAYMENT_VERIFICATION_RECOVERY');
